import React from 'react';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';

const FullscreenLoaderStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;

export const FullscreenLoader = (): JSX.Element => (
    <FullscreenLoaderStyled>
        <CircularProgress size={24} />
    </FullscreenLoaderStyled>
);
